import { CreateEditJobNavEnum, CreateJobErrorTypes } from 'containers/jobs/constant';
import { CreateJobContextType } from 'containers/jobs/types';
import { FC, useContext } from 'react';
import ScheduleSection from './ScheduleSection';
import { getBorderStyles, getJobValidationErrors } from 'containers/jobs/utils';
import { useAppSelector } from 'hooks';
import { selectJobValidationErrors } from '../createJobSlice';
import AssignMembersCheckboxSection from './AssignMembersCheckboxSection';
import useFSMPlanInfo from 'containers/integrations/fsm-integration/hooks/useFSMPlanInfo';
import AssignMembersSection from './AssignMembersSection';
import TagSelectionSection from './TagSelectionSection';
import { selectSelectedTags, updateSelectedTags } from '../createJobSlice';
import { useAppDispatch } from 'hooks';
import { Tag } from 'containers/tags/tags.model';

interface ScheduleAndAssignToProps {
  context: React.Context<CreateJobContextType>;
  isEdit: boolean;
}

const ScheduleAndAssignTo: FC<ScheduleAndAssignToProps> = ({ context, isEdit }) => {
  const { selectedJobTab, setSelectedJobTab } = useContext<CreateJobContextType>(context);
  const isTabSelected = selectedJobTab === CreateEditJobNavEnum.JOB_SCHEDULE;

  const selectedJobValidations = useAppSelector(selectJobValidationErrors);
  const { isActiveFSMPlusPlan } = useFSMPlanInfo();
  const selectedTags = useAppSelector(selectSelectedTags);
  const dispatch = useAppDispatch();

  const hasError = Boolean(
    getJobValidationErrors(selectedJobValidations, CreateJobErrorTypes.SCHEDULE_DATE) ||
      getJobValidationErrors(selectedJobValidations, CreateJobErrorTypes.ASSIGN_MEMBER)
  );

  const handleOnFocus = () => {
    setSelectedJobTab(CreateEditJobNavEnum.JOB_SCHEDULE);
  };

  const handleTagsChange = (tags: Tag[]) => {
    dispatch(updateSelectedTags(tags));
  };

  const borderStyle = getBorderStyles({
    isSelected: isTabSelected,
    hasError
  });

  return (
    <div className="w-full" onFocus={handleOnFocus}>
      <div className={`relative space-y-6 rounded-md border py-6 px-8 ${borderStyle}`}>
        <ScheduleSection isEdit={isEdit} />

        {isActiveFSMPlusPlan ? (
          <AssignMembersCheckboxSection context={context} isEdit={isEdit} />
        ) : (
          <AssignMembersSection context={context} />
        )}
        <TagSelectionSection selectedTags={selectedTags} onTagsChange={handleTagsChange} />
      </div>
    </div>
  );
};

export default ScheduleAndAssignTo;
